(() => {
  const products = new Map();
  const loadProduct = (url) => {
    const endpoint = new URL(url, location.origin);
    endpoint.search = '';
    endpoint.pathname = endpoint.pathname.replace(/\/$/, '') + '.js';
    if (!products.has(endpoint.href)) {
      products.set(endpoint.href, fetch(endpoint.href).then((response) => {
        if (!response.ok) throw new Error('Product unavailable');
        return response.json();
      }).catch(() => {
        products.delete(endpoint.href);
        return null;
      }));
    }
    return products.get(endpoint.href);
  };

  const expandRelated = (linked) => {
    linked.querySelectorAll('.lv-option-item-link').forEach(async (original) => {
      const source = original.closest('.lv-option-wrapper');
      if (!source || source.hidden || source.dataset.colorExpansion) return;
      source.dataset.colorExpansion = 'loading';
      const product = await loadProduct(original.href);
      if (!product || !source.isConnected) {
        source.dataset.colorExpansion = 'failed';
        original.classList.remove('linkedoption-color-cards__loading');
        return;
      }
      const index = product.options.findIndex((option) => /^(colou?r|couleur|farbe|цвет)$/i.test(typeof option === 'string' ? option : option.name));
      if (index < 0) {
        original.classList.remove('linkedoption-color-cards__loading');
        return;
      }
      const colors = new Map();
      product.variants.forEach((variant) => {
        const color = variant.options[index];
        const image = variant.featured_image?.src;
        if (image && (!colors.has(color) || (!colors.get(color).available && variant.available))) {
          colors.set(color, { ...variant, image });
        }
      });
      if (!colors.size) {
        original.classList.remove('linkedoption-color-cards__loading');
        return;
      }
      await Promise.all(Array.from(colors.values()).map((variant) => {
        const image = new Image();
        image.src = variant.image;
        return image.decode().catch(() => null);
      }));
      if (!source.isConnected) return;
      colors.forEach((variant, color) => {
        const key = product.id + ':' + color;
        if (Array.from(linked.querySelectorAll('[data-card-key]')).some((item) => item.dataset.cardKey === key)) return;
        const wrapper = document.createElement('div');
        wrapper.className = 'lv-option-wrapper linkedoption-color-cards__related';
        const card = document.createElement('a');
        card.className = 'lv-option-item-outer';
        card.dataset.cardKey = key;
        card.title = color;
        card.setAttribute('aria-label', product.title + ' — ' + color);
        const url = new URL(original.href, location.origin);
        url.searchParams.set('variant', variant.id);
        card.href = url.href;
        card.style.backgroundImage = 'url(' + JSON.stringify(variant.image) + ')';
        wrapper.append(card);
        source.before(wrapper);
      });
      source.hidden = true;
      source.dataset.colorExpansion = 'done';
    });
  };
  const colorFieldset = (scope) => Array.from(scope.querySelectorAll('variant-selects fieldset')).find((fieldset) => {
    const legend = fieldset.querySelector('legend');
    return /^(Color|Colour|Couleur|Farbe|Цвет)\s*:/i.test(legend?.textContent?.trim() || '');
  });

  const setLabel = (label, value) => {
    const locale = document.documentElement.lang.split('-')[0];
    const prefix = { fr: 'Couleur', de: 'Farbe', ru: 'Цвет', es: 'Color' }[locale] || 'Color';
    const text = prefix + ': ' + (value || '');
    if (label.textContent !== text) label.textContent = text;
  };

  const selectedColor = (productInfo, fieldset) => {
    return productInfo.querySelector('.linkedoption-color-cards__native input[type="radio"]:checked')?.value
      || fieldset.querySelector('input[type="radio"]:checked')?.value
      || '';
  };

  const sync = () => {
    document.querySelectorAll('product-info').forEach((productInfo) => {
      const fieldset = colorFieldset(productInfo);
      if (!fieldset) return;

      const linked = productInfo.querySelector('king-linked-options-product .lv-option-group');
      const app = linked?.closest('king-linked-options-product');
      const size = Array.from(productInfo.querySelectorAll('variant-selects fieldset')).find((item) => {
        const legend = item.querySelector('legend');
        return /^(Size|Taille|Größe|Размер|Talla|Tamaño)\s*:/i.test(legend?.textContent?.trim() || '');
      });
      const legend = fieldset.querySelector('legend');
      const current = selectedColor(productInfo, fieldset);

      if (!linked || !app) return;
      if (fieldset.querySelector('[data-color-card]')) fieldset.dataset.imageCardsReady = 'true';
      if (fieldset.dataset.imageCardsReady !== 'true') {
        if (fieldset.dataset.imageCardsLoading === 'true') return;
        fieldset.dataset.imageCardsLoading = 'true';
        loadProduct(productInfo.querySelector('variant-selects').dataset.url || location.pathname).then((product) => {
          if (!product || !fieldset.isConnected) return;
          const index = product.options.findIndex((option) => /^(colou?r|couleur|farbe|цвет)$/i.test(typeof option === 'string' ? option : option.name));
          fieldset.querySelectorAll('input[type="radio"]').forEach((input) => {
            const label = fieldset.querySelector('label[for="' + CSS.escape(input.id) + '"]');
            const variant = product.variants.find((item) => item.options[index] === input.value && item.featured_image?.src);
            if (!label || !variant) return;
            label.dataset.colorCard = '';
            label.dataset.productId = product.id;
            label.style.backgroundImage = 'url(' + JSON.stringify(variant.featured_image.src) + ')';
          });
          fieldset.dataset.imageCardsReady = 'true';
          sync();
        });
        return;
      }
      if (legend) setLabel(legend, current);

      let label = productInfo.querySelector('.linkedoption-color-cards__label');
      if (!label) {
        label = document.createElement('div');
        label.className = 'linkedoption-color-cards__label';
        app.before(label);
      }
      setLabel(label, current);

      if (fieldset.dataset.linkedoptionMerged !== 'true') {
        linked.querySelectorAll('.linkedoption-color-cards__native').forEach((item) => item.remove());

        Array.from(fieldset.querySelectorAll('input[type="radio"]')).forEach((input) => {
          const card = input.nextElementSibling;
          if (!card?.matches('[data-color-card]')) return;

          const wrapper = document.createElement('div');
          wrapper.className = 'lv-option-wrapper linkedoption-color-cards__native';
          const proxy = document.createElement('button');
          proxy.type = 'button';
          proxy.className = 'lv-option-item-outer';
          proxy.dataset.nativeColor = input.value;
          proxy.dataset.cardKey = card.dataset.productId + ':' + input.value;
          proxy.title = input.value;
          proxy.setAttribute('aria-label', input.value);
          proxy.style.backgroundImage = card.style.backgroundImage;
          proxy.addEventListener('click', () => input.click());
          wrapper.append(proxy);
          const currentCard = Array.from(linked.querySelectorAll('.lv-option-item-link')).find((item) => item.dataset.pid === card.dataset.productId);
          if (currentCard) {
            currentCard.closest('.lv-option-wrapper').before(wrapper);
            currentCard.closest('.lv-option-wrapper').hidden = true;
          } else linked.append(wrapper);
        });

        fieldset.classList.add('linkedoption-color-cards__source');
        fieldset.dataset.linkedoptionMerged = 'true';
      }

      linked.querySelectorAll('[data-native-color]').forEach((card) => {
        card.classList.toggle('lv-option-item__active', card.dataset.nativeColor === current);
        card.setAttribute('aria-pressed', String(card.dataset.nativeColor === current));
      });
      expandRelated(linked);

      if (size && !(label.nextElementSibling === app && app.nextElementSibling === size)) {
        size.before(label, app);
      }
      app.classList.add('linkedoption-color-cards__ready');
    });
  };

  new MutationObserver(sync).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('change', sync);
  sync();
})();
